module.exports = __webpack_public_path__ + "static/media/Intersection 30.fb035677.png";